import { useFormContext } from "react-hook-form"

import { Button } from "@mui/material"

import type { SubmitButtonProps } from "./submit-button.types"

export const SubmitButton = ({
  children,
  disabled,
  disableDirtyCheck,
  disableFormStateCheck,
  variant,
  ...rest
}: SubmitButtonProps) => {
  const methods = useFormContext()

  const { isValid, isDirty, isSubmitting } = methods.formState

  let isDisabled: boolean = disabled ?? false

  if (
    isSubmitting ||
    ((!isValid || (!isDirty && !disableDirtyCheck)) && !disableFormStateCheck)
  ) {
    isDisabled = true
  }

  return (
    <Button
      {...rest}
      disabled={isDisabled}
      type="submit"
      variant={variant ?? "contained"}
    >
      {children}
    </Button>
  )
}
